module.exports = __webpack_public_path__ + "img/folder.f8716ce1.svg";